import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import us from './us.json';
import vi from './vi.json';

// Initialize localStorage with default language if not set
const storedLang = localStorage.getItem('language');
const defaultLang = 'vi';

if (!storedLang || (storedLang !== 'vi' && storedLang !== 'en')) {
    localStorage.setItem('language', defaultLang);
}

const initialLang = localStorage.getItem('language') || defaultLang;

i18next.use(initReactI18next).init({
    resources: {
        en: { translation: us },
        vi: { translation: vi },
    },
    fallbackLng: defaultLang,
    lng: initialLang,
    interpolation: {
        escapeValue: false,
    },
});


export default i18n;
